import { default as InputFile } from './InputFile'

export default InputFile
